import React from 'react';
import { GraduationCapIcon, ScrollTextIcon, AwardIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { education, barAdmissions, certifications, accents } from '../../data/site';
export function Credentials() {
  return <section id="credentials" className="relative scroll-mt-24 overflow-hidden bg-white py-24 lg:py-32" data-id="element-101" data-mp="3fho5jygaogek">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-102" data-mp="3t92yoy3x1xzc">
        <SectionHeading eyebrow="Education & Credentials" title="Formally credentialed, multi-state licensed." data-id="element-103" data-mp="3tbp68xqt4dhk" />

        <div className="mt-16 grid gap-6 lg:grid-cols-3" data-id="element-104" data-mp="72xnqdpj2bnz">
          <Reveal className="lg:col-span-1" data-id="element-105" data-mp="70bgygago06t">
            <div className="h-full border border-navy/10 bg-mist p-8" data-id="element-106" data-mp="231n8og1h2d6">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-white" style={{
              backgroundColor: accents[0]
            }} data-id="element-107" data-mp="28tr7zeagnh2b">
                <GraduationCapIcon className="h-5 w-5" aria-hidden="true" data-id="element-108" data-mp="1tgesvwh7mge" />
              </span>
              <h3 className="mt-6 font-display text-xl font-normal text-navy" data-id="element-109" data-mp="1rn85glv528e">Education</h3>
              <ul className="mt-5 space-y-6" data-id="element-110" data-mp="5sp67u41n88s">
                {education.map(item => <li key={item.credential} data-id="element-111" data-mp="as1umjakcndh">
                    <p className="text-[0.7rem] uppercase tracking-[0.15em] text-violet" data-id="element-112" data-mp="fl4o6rfcbwto">{item.year}</p>
                    <p className="mt-1.5 text-sm font-medium text-navy" data-id="element-113" data-mp="kkr10zr9bb1y">{item.credential}</p>
                    <p className="mt-1 text-sm text-charcoal/65" data-id="element-114" data-mp="pi9e92cb4cfr">{item.institution}</p>
                    {item.detail ? <p className="mt-2 text-xs leading-relaxed text-charcoal/60" data-id="element-115" data-mp="tlxj3d9k0txb">{item.detail}</p> : null}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.07} data-id="element-116" data-mp="2ve3o4kfz6t2j">
            <div className="h-full border border-navy/10 bg-mist p-8" data-id="element-117" data-mp="30au1h00ebak9">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-white" style={{
              backgroundColor: accents[2]
            }} data-id="element-118" data-mp="30d6kzhlsxszf">
                <ScrollTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-119" data-mp="2jlm1nyk5gce" />
              </span>
              <h3 className="mt-6 font-display text-xl font-normal text-navy" data-id="element-120" data-mp="gilaovm2lv8k">Bar Admissions & Licenses</h3>
              <ul className="mt-5 space-y-3.5" data-id="element-121" data-mp="bkbfwm49cwnh">
                {barAdmissions.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-charcoal/75" data-id="element-122" data-mp="qdd5jro9q3zn">
                    <span className="mt-1.5 h-1.5 w-1.5 flex-none rotate-45 bg-teal" aria-hidden="true" data-id="element-123" data-mp="leabf29tti6g" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.14} data-id="element-124" data-mp="195pit9ggmpok">
            <div className="h-full border border-navy/10 bg-mist p-8" data-id="element-125" data-mp="1970m785ztvf5">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-white" style={{
              backgroundColor: accents[3]
            }} data-id="element-126" data-mp="1474eoyy37luu">
                <AwardIcon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="1srhcg0p5loo5" />
              </span>
              <h3 className="mt-6 font-display text-xl font-normal text-navy" data-id="element-128" data-mp="1dui8qnxfafyy">
                Certifications & Development
              </h3>
              <ul className="mt-5 space-y-3.5" data-id="element-129" data-mp="1isjslb2oajbh">
                {certifications.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-charcoal/75" data-id="element-130" data-mp="15154iptwrrxk">
                    <span className="mt-1.5 h-1.5 w-1.5 flex-none rotate-45 bg-gold" aria-hidden="true" data-id="element-131" data-mp="19ty99dpdn09n" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}